export const HELP_LINK = 'https://help.swile.co/hc/fr/requests/new'
